import { AgentEvent, LlmMessage } from '~/atoms/schemas/workflowSchemas';
import { ProcessedEvent } from '../types';
import { matchLlmMessagesWithEvents } from './matchLlmMessagesWithEvents';
import { processAgentEvents } from './processAgentEvents';

/**
 * Processes events and LLM messages, reconciles them, and returns a sorted array of processed events
 *
 * @param events - The agent events to process
 * @param llmMessages - The LLM messages to reconcile with the events
 * @returns - Sorted array of processed events with duplicates removed
 */
export const processEventsAndMessages = (
  events: AgentEvent[],
  llmMessages: LlmMessage[],
): ProcessedEvent[] => {
  // Skip processing if there are no events
  if (!events.length) return [];

  // First, process all agent events into a map
  const eventMap = processAgentEvents(events);

  // Next, match and reconcile LLM messages with events
  const updatedEventMap = matchLlmMessagesWithEvents(
    eventMap,
    llmMessages,
    events.length,
  );

  // Convert map to array, filter out replaced events, and sort by timestamp
  return Array.from(updatedEventMap.values())
    .filter((event) => !event.replacedByLlmMessage)
    .sort((a, b) => {
      // Sort by timestamp - oldest first, newest last
      return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    });
};
